import Image from "next/future/image";

import competitiveSalaryIcon from "assets/careers/benefits/competitive-salary@2x.png";
import generousStockOptionsIcon from "assets/careers/benefits/generous-stock-options@2x.png";
import endOfYearBonusIcon from "assets/careers/benefits/end-of-year-bonus@2x.png";
import parentalLeaveIcon from "assets/careers/benefits/parental-leave@2x.png";
import flexibleTimeOffIcon from "assets/careers/benefits/flexible-time-off@2x.png";
import buildYourWorkspaceIcon from "assets/careers/benefits/build-your-workspace@2x.png";
import corporateCardIcon from "assets/careers/benefits/corporate-card@2x.png";
import healthPerksIcon from "assets/careers/benefits/health-perks@2x.png";

import SectionHeader from "./SectionHeader";

import styles from "./Benefits.module.css";

const benefits = [
  {
    title: "Competitive salary",
    description: "We pay you a location independent rate",
    icon: competitiveSalaryIcon,
  },
  {
    title: "Stock options",
    description: 'We don\'t treat "act like an owner" as a phrase',
    icon: generousStockOptionsIcon,
  },
  {
    title: "End of year bonus",
    description: "We value going the extra mile",
    icon: endOfYearBonusIcon,
  },
  {
    title: "Parental leave",
    description: "We provide 3 months paid time off",
    icon: parentalLeaveIcon,
  },
  {
    title: "Flexible time off",
    description: "We recommend at least 25 days",
    icon: flexibleTimeOffIcon,
  },
  {
    title: "Build your workspace",
    description: "Order your own equipment to onboard",
    icon: buildYourWorkspaceIcon,
  },
  {
    title: "Corporate card",
    description: "Use it on whatever makes you productive",
    icon: corporateCardIcon,
  },
  {
    title: "Health perks",
    description: "From insurance to gym. Stay healthy!",
    icon: healthPerksIcon,
  },
];

const Benefits = () => (
  <div className={styles.benefits}>
    <SectionHeader title="Our benefits" anchor="our-benefits">
      We put people first and want to empower everybody at Raycast to do your best work.
    </SectionHeader>
    <div className={styles.cardsWrapper}>
      {benefits.map((benefit, index) => (
        <div className={styles.card} key={index}>
          <Image alt="" src={benefit.icon} className={styles.benefitIcon} />
          <strong className={styles.benefitTitle}>{benefit.title}</strong>
          <p className={styles.benefitDescription}>{benefit.description}</p>
        </div>
      ))}
    </div>
  </div>
);

export default Benefits;
